/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint-disable-next-line max-len */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state", "payload"] }] */

const state = {
  // meta-data
  meta: {
    // current title for all views without view-specific titles
    title: 'create your own custom patches',
    // current description for all views without view-specific descriptions
    description:
      'Memerhats are the only hats on earth as dynamic and unique as you are. Shop our printed vinyl patches or create your own designs. Free shipping on all orders.',
    // applied to the end of all titles
    titleSuffix: ' | MemerHats Ltd.',
  },

  // enable/disable 'coming soon' mode
  comingSoon: true,

  // navigation drawers & menus
  navMenu: false,
  favoritesDrawer: false,
  cartDrawer: false,
  globalSnackbar: {
    timeout: 2000,
    text: '',
  },
};

const getters = {
  isComingSoon(state) {
    return state.comingSoon;
  },
};

const mutations = {
  setNavMenu(state, navMenu) {
    if (navMenu === false) {
      document.querySelector('html').classList.remove('overflow-y-hidden');
    }
    if (navMenu === true) {
      document.querySelector('html').classList.add('overflow-y-hidden');
    }
    state.navMenu = navMenu;
  },
  setFavoritesDrawer(state, favoritesDrawer) {
    state.favoritesDrawer = favoritesDrawer;
  },
  setCartDrawer(state, cartDrawer) {
    state.cartDrawer = cartDrawer;
  },
  setGlobalSnackbar(state, text) {
    state.globalSnackbar.text = text;
  },
};

const actions = {
  openMenu({ commit, dispatch }, menu) {
    dispatch('closeAllDrawers');
    switch (menu) {
      case 'navMenu':
        commit('setNavMenu', true);
        break;
      case 'favoritesDrawer':
        commit('setFavoritesDrawer', true);
        break;
      case 'cartDrawer':
        commit('setCartDrawer', true);
        break;
      default: // if no itemSet, do nothing
        break;
    }
  },
  closeAllDrawers({ commit }) {
    commit('setNavMenu', false);
    commit('setFavoritesDrawer', false);
    commit('setCartDrawer', false);
  },
  globalMessage({ commit }, text) {
    commit('setGlobalSnackbar', text);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
